module.exports = __webpack_public_path__ + "img/app_2.6d610885.jpg";